import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { array } from '@afosto/app-components-react/DataGrid/formatters';

const RolesFormatter = ({ roles }) => {
  const intl = useIntl();
  const translatedRoles = roles.reduce(
    (acc, role) => [
      ...acc,
      intl.formatMessage({
        id: `roles.${role}`,
        defaultMessage: role,
        description: `The translated value for role ${role}`,
      }),
    ],
    [],
  );

  return <>{array(translatedRoles)}</>;
};

RolesFormatter.propTypes = {
  roles: PropTypes.array,
};

RolesFormatter.defaultProps = {
  roles: [],
};

export default RolesFormatter;
